import React from "react"
import { useStyles } from "@/components/TextInputWithCounter/TextInputWithCounter.styles"
import { useFormContext } from "react-hook-form"
import { ControlledComponentProps, TextInput } from "@/components"
import { TextInputProps } from "@mantine/core"

type Props = ControlledComponentProps<TextInputProps> & { initializingFn?: (node, onChange) => void } & {
    maxChars: number
}

export function TextInputWithCounter({ maxChars, ...props }: Props) {
    const formContext = useFormContext()
    const hasError = Boolean(formContext.formState.errors[props.name]?.message)
    const { classes } = useStyles({ hasError })
    const value = formContext.watch(props.name)

    return (
        <div className={classes.wrapper}>
            <TextInput {...props} />
            <div className={classes.counter}>
                <span className={classes.letterAmount}>{value?.length || 0}</span>/{maxChars}
            </div>
        </div>
    )
}
